var _style, _g, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}.st1{fill:#4277AD;}.st2{fill:#69B631;}.st3{fill:#FFCC02;}.st4{fill:#9E7215;}.st5{fill:#62A9FF;}.st6{fill:#2C3E50;}.st7{fill:#B3B3B3;}.st8{fill:#B23A3A;}.st9{fill:#346BA9;}.st10{fill:#171717;}.st11{opacity:0.5;fill:#62A9FF;}.st12{fill:#676767;}.st13{fill:#E56615;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    className: "st5",
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12,
    className: "st5",
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    className: "st5",
    width: 3,
    height: 2
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12,5 9,5 9,2 7,2 7,5 4,5 4,7 7,7 7,10 9,10 9,7 12,7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.c509a29a75c1627fb67c70a9c4978c79.svg";
export { ForwardRef as ReactComponent };